module.exports = __webpack_public_path__ + "media/images/pic/anime/marker-51d4644f554ce171ceb0666e940a36f0.svg";